export const EVENT_DETAIL = {
	name: 'Khruangbin',
	datetime: 'Saturday, 31 Jan · 20:30',
	city: 'City Winery',
	distance: '0.2 Miles away',
};
